// Modules
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { translate } from 'react-translate';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Wrapper = styled.div`
  display: flex;
  margin-left: 8px;
  border-bottom: ${(props) => (props.open ? 'none' : '0.5px solid #cecece')};
  padding-top: 20px;
  padding-bottom: 20px;
  transition: all 0.5s ease-in-out;
  display: 'flex';
  margin-right: 10px;
`;

const Color = styled.div`
  width: 4px;
  height: ${(props) => (props.open ? '16px' : '40px')};
  background-color: ${(props) => props.color};
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 16px;
`;

const Name = styled.div`
  text-align: left;
  color: #4c5564;
  font-size: ${(props) => (props.open ? '16px' : '14px')};
  font-weight: ${(props) => (props.open ? '600' : '400')};
  width: 90%;
`;

const OpenChilds = styled.div`
  text-align: left;
  color: #187db5;
  font-size: 14px;
  cursor: pointer;
  display: ${(props) => (props.open ? 'none' : 'block')};
`;

const CheckWrapper = styled.div`
  display: ${(props) => (props.open ? 'none' : 'flex')};
  margin-right: 10px;
`;

function GroupItem(props) {
  return (
    <>
      <Wrapper open={props.isOpen}>
        {props.isOpen && props.hasParent && (
          <FontAwesomeIcon
            onClick={() => props.closeGroup()}
            icon={['fad', 'arrow-left']}
            style={{
              color: '#8C97A8',
              marginRight: '24px',
              marginTop: '2px',
              cursor: 'pointer',
            }}
          />
        )}
        <Color color={props.color} open={props.isOpen} />
        <>
          <Name open={props.isOpen}>
            {props.name}
            {props.hasChild && (
              <OpenChilds open={props.isOpen} onClick={() => props.openGroup(props.id)}>
                Abrir
              </OpenChilds>
            )}
          </Name>
        </>
        <CheckWrapper open={props.isOpen}>
          <input type="radio" checked={props.selected} onChange={() => props.onSelect()} />
        </CheckWrapper>
      </Wrapper>
    </>
  );
}

GroupItem.propTypes = {
  t: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    mediasReducer: state.mediasReducer,
  };
}

export default connect(mapStateToProps)(translate('Medias')(GroupItem));
